import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { WizardHpModelFilterSimulateurComponent } from 'projects/hp-api/src/lib/simulateur/wizard-menu/wizard-hp-model-filter-simulateur-component';
import { AppBaseModule } from '../../app-entry/app.base.module';


@Component({
  selector: 'app-wizard-multi-menu',
  templateUrl: './wizard-multi-menu.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-multi-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardMultiMenuComponent extends WizardHpBaseComponent implements OnInit {
  @ViewChild('simulateurFilter', { static: false }) simulateurFilter: WizardHpModelFilterSimulateurComponent;

  panelOpenState = false;
  @Input() asideTabletState: string = "in";
  @Input() multiMenuAnswerState: string = "in";
  @Input() vuId = false;
  @Input() productsGlobalDtata:any;
  @Input() catalog_selected:any;
  @Input() current_question:any = {};
    
  toggleSlide = [];
  layers = [1, 2, 3, 4, 5, 6];
  layeron = [];
  gamme_filter: any;
  modele_filter: any;
  checkFilterModele = [];
  modeleFilter_selected = [];
  collection_selected = [];
  collection_keywords = [];
  rootKey: any;
  panneaux = [];
  
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getHpService().emitDataChange();
   
    
  }





}
